import trade from './trade';
import transfers from './transfers';
import widgets from './widget';
export default {
    trade,
    transfers,
    widgets
};
